






















import { Component, Vue } from "vue-property-decorator";
@Component
export default class App extends Vue {
  get keepAlive() {
    return this.$route.meta!.keepAlive;
  }
  mounted() {
    this.$store.commit("SET_STATE", {
      appId: this.$route.query.appId || "10",
      parentCode: this.$route.query.parentCode || "1150"
    });
  }
}
